import { IonIcon } from '@ionic/react'
import { checkmark, flagOutline, locationOutline } from 'ionicons/icons'
import type { WaypointPosition } from './types'

/** Check when done, yard icon (pin out, flag back) or the stop number. */
const NodeContent = ({
  isCompleted,
  isFirst,
  stopNumber,
}: {
  isCompleted: boolean
  isFirst: boolean
  stopNumber?: number
}) => {
  if (isCompleted) return <IonIcon icon={checkmark} />
  if (stopNumber == null) {
    return <IonIcon icon={isFirst ? locationOutline : flagOutline} />
  }
  return <span>{stopNumber}</span>
}

/** Timeline track: connector – node – connector (v1 WaypointNumber). */
export const WaypointNumber = ({
  isFirst,
  isLast,
  isCompleted,
  stopNumber,
}: WaypointPosition & {
  /** 1-based stop number; omit for yard/HQ stops (icon instead). */
  stopNumber?: number
}) => {
  const isYard = stopNumber == null
  return (
    <div className='route-timeline__track'>
      <div
        className={`route-timeline__connector ${isFirst ? 'route-timeline__connector--hidden' : ''} ${isCompleted ? 'route-timeline__connector--done' : ''}`}
      />
      <div
        className={`route-timeline__node ${isYard ? 'route-timeline__node--yard' : ''} ${isCompleted ? 'route-timeline__node--done' : ''}`}
      >
        <NodeContent
          isCompleted={isCompleted}
          isFirst={isFirst}
          stopNumber={stopNumber}
        />
      </div>
      <div
        className={`route-timeline__connector ${isLast ? 'route-timeline__connector--hidden' : ''} ${isCompleted ? 'route-timeline__connector--done' : ''}`}
      />
    </div>
  )
}
